import * as React from 'react'
import { StyledBlock } from './BorderedText.styles'
import { Text } from '../Text'
import { Block } from '../Layout/Block'

interface Props {
  options: string[]
  mini?: boolean
}

export const BorderedText: React.SFC<Props> = ({ options, mini }) => {
  return (
    <Block flex wrap="wrap">
      {options.map((lang, index) => (
        <StyledBlock options={options} mini={mini} marginBottom="base" key={index}>
          <Text textAlign="center" weight="medium" menu>
            {lang}
          </Text>
        </StyledBlock>
      ))}
    </Block>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/BorderedText/BorderedText.tsx